module.exports = __webpack_public_path__ + "static/img/app01.a9a457c.png";


//////////////////
// WEBPACK FOOTER
// ./static/appPic/app01.png
// module id = NExf
// module chunks = 1